/*
 * AQS scroll-reveal — fade/slide-up as elements enter the viewport.
 * Reveals both:
 *   1. any element with [data-aqs-reveal] (opt-in, any page), and
 *   2. homepage sections (auto, when <body> has .aqs-home), skipping the hero
 *      and ticker.
 * The `.aqs-reveal` class is only added by JS, so with no JS (or reduced
 * motion) content stays fully visible.
 */
(function () {
  if (window.__aqsRevealInit) return;
  window.__aqsRevealInit = true;

  function init() {
    var reduce =
      window.matchMedia &&
      window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce || !('IntersectionObserver' in window)) return;

    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('aqs-in');
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
    );

    var seen = [];

    // 1) Explicit opt-in elements (any page).
    Array.prototype.forEach.call(
      document.querySelectorAll('[data-aqs-reveal]'),
      function (el) {
        el.classList.add('aqs-reveal');
        io.observe(el);
        seen.push(el);
      }
    );

    // 2) Homepage sections (skip hero [0] and ticker [1]).
    if (document.body.classList.contains('aqs-home')) {
      var main = document.querySelector('main');
      if (main) {
        var sections = Array.prototype.slice.call(
          main.querySelectorAll(':scope > .shopify-section')
        );
        sections
          .filter(function (el, i) {
            return i > 1 && seen.indexOf(el) === -1;
          })
          .forEach(function (el) {
            el.classList.add('aqs-reveal');
            io.observe(el);
          });
      }
    }

    // 3) Blog index cards (tossed-newspaper reveal).
    if (document.body.classList.contains('aqs-blog')) {
      Array.prototype.forEach.call(
        document.querySelectorAll('.blog-post-item'),
        function (el) {
          if (seen.indexOf(el) !== -1) return;
          el.classList.add('aqs-reveal');
          io.observe(el);
        }
      );
    }
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
